/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { FormattedMessage } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import Heading from '@atlaskit/heading/heading';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { token } from '@atlaskit/tokens';

import { CloseButton } from '../CloseButton';
import { messages } from '../messages';

const styles = cssMap({
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingBlock: token('space.150'),
		paddingInline: token('space.200'),
		borderBottomWidth: token('border.width'),
		borderBottomStyle: 'solid',
		borderBottomColor: token('color.border'),
	},
});

type ChatHeaderProps = {
	onClose: () => void;
	title?: string;
	testId?: string;
};

export const ChatHeader = ({
	onClose,
	title,
	testId = 'chat-header',
}: ChatHeaderProps): JSX.Element => (
	<Flex xcss={styles.header} testId={testId}>
		<Heading size="small">{title ?? <FormattedMessage {...messages.heading} />}</Heading>
		<CloseButton onClick={onClose} testId={`${testId}-close-button`} />
	</Flex>
);
